exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\nhtml{\r\nmin-height: 97vh !important ;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/playitadmin_frontend/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!D:/xampp/htdocs/playitadmin_frontend/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!D:/xampp/htdocs/playitadmin_frontend/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles